import React from "react";

const TenurePremiumModal = () => {
  return (
    <div className="mt-2 text-center">
      <div className="alert px-4 py-3" role="alert">
        <h5 className="mb-3" style={{ fontSize: "16px" }}>
          This Contract Tenure is a Premium plan feature. Please contact the
          LoRRI team to enable access for your account.
        </h5>
      </div>

      <p className="mt-3" style={{ fontSize: "15px", lineHeight: "1.5" }}>
        Should you need any assistance or have a question, please email
        <a href="mailto:associate@logisticsnow.in" className="mx-1">
          associate@logisticsnow.in
        </a>
        or call
        <span className="ms-1">+91-9867773508 / +91-9653620207</span>
      </p>
    </div>
  );
};

export default TenurePremiumModal;
